module.exports = __webpack_public_path__ + "static/img/02.3f6be9a8.jpg";